// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-account-panel-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(220, 224, 255, 0.411);
  padding:20px;
  border-radius: 10px;
}


.create-account-panel-form-container {
  width: 80%;
}
.create-account-panel-title-container {
  display: flex;
  justify-content: center;
  font-size: xx-large;
  margin: 5px;
}


.create-account-panel-description-container {
  /* width: 90%; */
  /* border: black;
  border-width: 1px;
  border-style: solid; */
  background-color: rgba(211, 207, 192, 0.1);
  border-radius: 10px;
  font-weight: bold;
  margin: 10px;
  margin-bottom: 30px;
  /* padding:0px; */
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Unauthed/Login/CreateAccountPanel/CreateAccountPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,gBAAgB;EAChB;;wBAEsB;EACtB,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".create-account-panel-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: rgba(220, 224, 255, 0.411);\n  padding:20px;\n  border-radius: 10px;\n}\n\n\n.create-account-panel-form-container {\n  width: 80%;\n}\n.create-account-panel-title-container {\n  display: flex;\n  justify-content: center;\n  font-size: xx-large;\n  margin: 5px;\n}\n\n\n.create-account-panel-description-container {\n  /* width: 90%; */\n  /* border: black;\n  border-width: 1px;\n  border-style: solid; */\n  background-color: rgba(211, 207, 192, 0.1);\n  border-radius: 10px;\n  font-weight: bold;\n  margin: 10px;\n  margin-bottom: 30px;\n  /* padding:0px; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
